<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">{{ t('addNewChild.release.title') }}</h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    <div mat-dialog-content>
      <form class="grid grid-cols-2 gap-x-10" [formGroup]="releaseStudentForm">

        <div class="col-span-full md:col-span-1 pt-3">
          <label class="font-normal" for="Name">{{ t('addNewChild.release.childName') }}</label>
          <!-- Server-supplied child name: not translated. -->
          <p>{{child.firstName + ' ' + child.lastName}}</p>
        </div>

        <div class="col-span-full md:col-span-1 pt-4">
          <mat-form-field class="example-full-width no-underline" appearance="fill">
            <label class="font-normal">{{ t('addNewChild.release.reason') }}<span class="required"></span></label>
            <mat-select formControlName="classReleaseReasonId" [placeholder]="t('addNewChild.release.reasonPlaceholder')">
              @for (reason of releaseReasons$ | async; track reason) {
                <!-- Server-supplied release reason: not translated. -->
                <mat-option [value]="reason.id"
                (click)="getSelectedReleaseReason(reason)"> {{ reason.releaseReason }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (isOther) {
          <div class="col-span-full">
            <mat-form-field class="bg-white" appearance="fill">
              <label class="font-normal" for="comment">{{ t('addNewChild.release.comment') }}</label>
              <input matInput [placeholder]="t('addNewChild.release.commentPlaceholder')" autocomplete="off" type="text" formControlName="comment">
            </mat-form-field>
          </div>
        }

      </form>

    </div>
  </div>
  <div mat-dialog-actions class="flex justify-end pt-4">
    <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('addNewChild.common.cancel') }}</drdp-btn>
    <drdp-btn class="ml-3" mat-button [disabled]="releaseStudentForm.invalid" cdkFocusInitial (click)="onSubmit()">{{ t('addNewChild.release.submit') }}</drdp-btn>
  </div>
</ng-container>
